import { Box, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';

interface Props {
    label: string;
    error?: string;
    maxWidth?: string | number;
    children: ReactNode;
}

const INPUT_HEIGHT = 40;

export default function PrefillField({ label, error, maxWidth = '320px', children }: Props) {
    return (
        <Stack
            sx={{
                width: { xs: '100%', md: maxWidth },
                maxWidth: '100%',
            }}
            gap={0.5}
        >
            <Typography
                component="label"
                variant="caption"
                fontWeight={500}
                color="#202124"
                sx={{ lineHeight: '16px' }}
            >
                {label}
            </Typography>
            <Box
                sx={{
                    height: INPUT_HEIGHT,
                    display: 'flex',
                    alignItems: 'center',
                    '& > *': {
                        width: '100%',
                    },
                    '& .MuiFormHelperText-root': {
                        display: 'none',
                    },
                    '& .MuiTextField-root': {
                        mt: '0 !important',
                    },
                }}
            >
                {children}
            </Box>
            {error && (
                <Typography
                    variant="caption"
                    color="error"
                    sx={{
                        display: 'block',
                        lineHeight: '16px',
                    }}
                >
                    {error}
                </Typography>
            )}
        </Stack>
    );
}
